// extracted by mini-css-extract-plugin
export default {"quillCell":"QuillColumn_quillCell__59CjG"};